module.exports = __webpack_public_path__ + "static/img/1.1549c13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/store_files/images/bba/1242x2208/1.png
// module id = p6BS
// module chunks = 0